"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rodape = void 0;
var react_1 = __importDefault(require("react"));
var LogoMicroUniverso_1 = require("../LogoMicroUniverso/LogoMicroUniverso");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Avatar_1 = require("../Avatar/Avatar");
var estiloRodape = require("./Rodape.module.scss");
var Rodape = function (_a) {
    var sombreado = _a.sombreado, redirecionarPagina = _a.redirecionarPagina, onClick = _a.onClick, abrirNovaAba = _a.abrirNovaAba, _b = _a.telaLogin, telaLogin = _b === void 0 ? false : _b, filialLoja = _a.filialLoja, nomeApi = _a.nomeApi, versaoApi = _a.versaoApi, style = _a.style, versao = _a.versao, avatar = _a.avatar;
    var avatarRender = function () {
        return (react_1.default.createElement("div", { className: estiloRodape.avatar }, avatar && (react_1.default.createElement(Avatar_1.Avatar, { src: avatar.src, alt: avatar.alt, tamanho: avatar.tamanho, tipo: avatar.tipo, showNotificacao: avatar.showNotificacao, notificacao: avatar.showNotificacao
                ? avatar.notificacao
                : undefined }))));
    };
    var filialRender = function () {
        return (react_1.default.createElement("div", { className: estiloRodape.informacoesRenderizadas },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, "Filial"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, filialLoja)));
    };
    var versaoApiLabel = (react_1.default.createElement("div", { className: estiloRodape.informacoesRenderizadas },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, nomeApi !== null && nomeApi !== void 0 ? nomeApi : "Api Enterprise"),
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, versaoApi)));
    var versaoRender = function () {
        return (react_1.default.createElement("div", { className: estiloRodape.informacoesRenderizadas },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, "Vers\u00E3o"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, versao)));
    };
    var anoAtual = new Date().getFullYear();
    return (react_1.default.createElement("div", { style: __assign({}, style), className: "".concat(estiloRodape.container, " ").concat(estiloRodape[sombreado ? "sombreado" : ""]) },
        telaLogin === false && (react_1.default.createElement("div", { className: estiloRodape.conteudoEsquerda },
            avatarRender(),
            filialRender(),
            versaoApiLabel,
            versaoRender())),
        react_1.default.createElement("div", { className: estiloRodape.conteudoDireita },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 },
                " ",
                "\u00A9 1983 / ",
                anoAtual,
                " - Todos os direitos reservados",
                " "),
            react_1.default.createElement("a", { href: redirecionarPagina !== null && redirecionarPagina !== void 0 ? redirecionarPagina : "https://www.microuniverso.com.br/", onClick: onClick, target: abrirNovaAba ? "_blank" : "_self" },
                react_1.default.createElement(LogoMicroUniverso_1.LogoMicroUniverso, { tipoLogo: "LogoMURodape", className: "".concat(estiloRodape.logo) })))));
};
exports.Rodape = Rodape;
